import { render, staticRenderFns } from "./movebackModal.vue?vue&type=template&id=db88441c"
import script from "./movebackModal.vue?vue&type=script&lang=js"
export * from "./movebackModal.vue?vue&type=script&lang=js"
import style0 from "./movebackModal.vue?vue&type=style&index=0&id=db88441c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports